import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { PeriodProvider } from "components/PeriodContext"; // Import PeriodProvider
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FXBullsheetTradeOptimizer from "components/FXBullsheetTradeOptimizer"; // Your calculator component

const FXBullsheetTradeOptimizerLayout = ({ userID, initialCapital, userData }) => {
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is signed in with UID:", user.uid);
      } else {
        console.log("User is signed out");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PeriodProvider>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <FXBullsheetTradeOptimizer />
              </MDBox>
            </Grid>
          </Grid>
        </PeriodProvider>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

FXBullsheetTradeOptimizerLayout.propTypes = {
  userID: PropTypes.string.isRequired,
  initialCapital: PropTypes.number.isRequired,
  userData: PropTypes.object,
};

export default FXBullsheetTradeOptimizerLayout;
